import '../styles/dashboard-region-status.css';

export default function DrilldownModal({ title, onClose, children }) {
  return (
    <div className="dashboard-drilldown-overlay" onClick={onClose}>
      <div className="dashboard-drilldown-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dashboard-drilldown-header">
          <h4 className="dashboard-drilldown-title">{title}</h4>
          <button className="dashboard-drilldown-close" onClick={onClose} type="button">×</button>
        </div>
        <div className="dashboard-drilldown-body">
          {children}
        </div>
      </div>
    </div>
  );
}
